import { useUrlSelectLayer, useWMSProperties } from "hooks/layerSetHooks";
import { WMSTileLayer } from "react-leaflet";
import { LayerSet } from "types/types";

interface Props {
  layerSet: LayerSet;
}

export function RenderSelectedLayer(props: Props) {
  const { layerSet } = props;
  const { selectedLayer } = useUrlSelectLayer(layerSet.layerList);
  const wmsLayer = useWMSProperties(selectedLayer.geoserverLayer);

  return <WMSTileLayer zIndex={100} key={selectedLayer.id} {...wmsLayer} />;
}
